import { render, staticRenderFns } from "./ClassCate.vue?vue&type=template&id=582fd2c7&scoped=true&"
import script from "./ClassCate.vue?vue&type=script&lang=js&"
export * from "./ClassCate.vue?vue&type=script&lang=js&"
import style0 from "./ClassCate.vue?vue&type=style&index=0&id=582fd2c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582fd2c7",
  null
  
)

export default component.exports